/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * Profileservice.ts
 */

import KareviAPIService from "../tools/service/KareviAPIService";
import Profile from "../models/Profile";
import QueryFilter from "../tools/model/pagination/Filters";
import {Listener} from "../tools/service/Service";
import {Selectable} from "../tools/model/form/Selectable";
import {PaginationFilters} from "../tools/pagination/PaginationFilters";

export default class ProfileService extends KareviAPIService<Profile, Listener<Profile>> {
    public static SINGLE_ROUTE = '/profile/{profileId}';
    public static CATALOG_UPDATE_ROUTE = '/profile/{profileId}/catalog';
    public static LIST_ROUTE = '/profiles';
    public static id = "ProfileService";

    public static convertToSelectable(profiles: Array<Profile>): Array<Selectable<Profile>> {
        let result: Array<Selectable<Profile>> = [];

        for (let profile of profiles) {
            result.push({
                value: profile,
                name: profile.name,
                disabled: false
            })
        }

        return result;
    }

    /**
     * start
     */
    public start() {
        super.start();
    }

    /**
     * stop
     */
    public stop() {
        super.stop();
    }

    /**
     * createProfile
     * @return {Promise<Profile>}
     * @param dto
     */
    public async createProfile(dto: Map<string, any> | FormData): Promise<Profile> {
        return await this.post(ProfileService.LIST_ROUTE, dto);
    }

    /**
     * updateProfile
     * @return {Promise<Profile>}
     * @param dto
     * @param profile
     */
    public async updateProfile(profile: Profile, dto: Map<string, any> | FormData): Promise<Profile> {
        const route = this.httpService.buildRoute(ProfileService.SINGLE_ROUTE, {
            profileId: profile.id
        });

        return await this.put(route, dto);
    }

    /**
     * updateProfile
     * @return {Promise<Profile>}
     * @param dto
     * @param profile
     */
    public async updateCatalogAttribution(profile: Profile, dto: Map<string, any> | FormData): Promise<Profile> {
        const route = this.httpService.buildRoute(ProfileService.CATALOG_UPDATE_ROUTE, {
            profileId: profile.id
        });

        console.log("dto: ", dto)
        return await this.post(route, dto);
    }

    /**
     * findById
     * @returns {Promise<void>}
     */
    public async findById(id: string): Promise<Profile> {
        const route = this.httpService.buildRoute(ProfileService.SINGLE_ROUTE, {
            profileId: id
        });

        return await this.getOne<Profile>(route);
    }

    /**
     * findAll
     * @returns {Promise<Profile[]>}
     */
    public async findAll(): Promise<Profile[]> {
        const profileFilters: QueryFilter<PaginationFilters> = new QueryFilter<PaginationFilters>({
            page: 0,
            size: 10000
        });

        return await this.getList<Profile, PaginationFilters>(ProfileService.LIST_ROUTE, profileFilters);
    }
}
